import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import CompanyComponent from "../components/CompanyComponent";
import equityIcon from "../../../assets/design-revamp-company/equity-component/equity-icon.svg";
import {
  updateEquityInvestment,
  deleteEquityInvestment,
  getEquityInvestment,
} from "../../../apis/Business/EquityInvestmentApi";
import Equity from "../Equity";
import { AlertV2 } from "../../../components/Alert";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

const EditEquity = () => {
  const { t } = useTranslation();
  const { equityId } = useParams();
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");
  const [nickname, setNickname] = useState("");
  const [investeeName, setInvesteeName] = useState("");
  const [country, setCountry] = useState("");
  const [shareEquity, setShareEquity] = useState("");
  const [ownershipStructure, setOwnershipStructure] = useState("");
  const [scope1, setScope1] = useState("");
  const [scope2, setScope2] = useState("");
  const [errorMessage, setErrorMessage] = useState({});
  const navigate = useNavigate();
  const [deleteFacilityAlert, setDeleteFacilityAlert] = useState(false);
  const [cutOffAddress, setCutOffAddress] = useState("");
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  useEffect(() => {
    if (year == null || year === "") {
      navigate("/company");
    }
  }, [navigate, year]);

  const handleMove = useCallback(
    () => navigate("/company", { replace: true }),
    [navigate]
  );

  const handleFormDataChange = (updatedFormData) => {
    setInvesteeName(updatedFormData.investeeName);
    setNickname(updatedFormData.nickname);
    setCountry(updatedFormData.country);
    setShareEquity(updatedFormData.shareEquity);
    setOwnershipStructure(updatedFormData.ownershipStructure);
    setScope1(updatedFormData.scope1);
    setScope2(updatedFormData.scope2);
  };

  const save = () => {
    updateEquityInvestment({
      objectId: equityId,
      nickname: nickname,
      investee_name: investeeName,
      country: country,
      share_equity: shareEquity,
      ownership_structure: ownershipStructure,
      scope_1: scope1,
      scope_2: scope2,
      setErrorMessage: setErrorMessage,
      use_swal: true,
      callback: () =>
        setTimeout(() => {
          window.location.reload();
        }, 1000),
    });
  };

  useEffect(() => {
    getEquityInvestment({
      objectId: equityId,
      setNickname: setNickname,
      setInvesteeName: setInvesteeName,
      setCountry: setCountry,
      setShareEquity: setShareEquity,
      setOwnershipStructure: setOwnershipStructure,
      setScope1: setScope1,
      setScope2: setScope2,
      setIsDataLoaded: setIsDataLoaded,
    });
  }, [equityId]);

  const handleDelete = () => {
    setDeleteFacilityAlert(true);
  };

  const handleSave = () => {
    save();
    return;
  };

  return (
    <>
      <div
        className="companydetail"
        style={{
          display: "flex",
          flexDirection: "row",
          paddingRight: "42px",
          marginTop: "20px",
        }}
        id="equity-id"
      >
        <CompanyComponent
          name={investeeName}
          address_line_1={cutOffAddress !== "" ? cutOffAddress : country}
          iconComponent={equityIcon}
        />
        {isDataLoaded && (
          <Equity
            initialData={{
              nickname,
              investeeName,
              country,
              shareEquity,
              ownershipStructure,
              scope1,
              scope2,
            }}
            isNewFacility={false}
            onFormDataChange={handleFormDataChange}
            handleSave={handleSave}
            errorMessage={errorMessage}
            setCurrentName={setInvesteeName}
            setCutOffAddress={setCutOffAddress}
            handleDelete={handleDelete}
          />
        )}
      </div>
      <AlertV2
        open={deleteFacilityAlert}
        title={t("DELETE_FACILITY_2")}
        accept={() => {
          deleteEquityInvestment({ objectId: equityId });
          handleMove();
        }}
        decline={() => setDeleteFacilityAlert(false)}
      />
    </>
  );
};

export default EditEquity;
